/** @format */

import React, { useCallback, useState } from 'react';
import { ListedLeadsLogFilterInput } from '../types/listedLeadsLog.types';
import ListedLeadsLogTable from '../components/ListedLeadsLogTable';

interface ListedLeadsLogTableContainerProps {
  filter?: ListedLeadsLogFilterInput;
}

const ListedLeadsLogTableContainer: React.FC<ListedLeadsLogTableContainerProps> = ({ filter }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <ListedLeadsLogTable
      filter={filter}
      refreshTrigger={refreshTrigger}
      onRefresh={handleRefresh}
    />
  );
};

export default ListedLeadsLogTableContainer;
